<template>
  <div>
    <div class="d-flex justify-content-between mb-3">
      <div>
        <div>Status: <span style="min-width: 10em;" class="d-inline-block">{{ Status }}</span></div>
        <div v-if="['R','N'].includes(statusMapped)">Rejection Reason: <span style="min-width: 10em;" class="d-inline-block">{{ RejectionOrAcceptanceCode }}</span></div>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <label for="RaisedDate" class="d-block">
          Raised Date
          <el-date-picker
            v-model="Received"
            format="dd.MM.yyyy"
            value-format="yyyy-MM-dd"
            class="float-right"
            type="date"
            disabled
          ></el-date-picker>
        </label>
      </div>
      <div class="col-6">
        <label for="ContactDate" class="d-block">
          Contact Date
          <el-date-picker
            v-model="CustomerContactDate"
            format="dd.MM.yyyy"
            value-format="yyyy-MM-dd"
            class="float-right"
            type="date"
            disabled
          ></el-date-picker>
        </label>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <label for="OldSupplier" class="d-block">
          Old Supplier
          <b-form-input v-model="LosingSupplierId" type="text" disabled/>
        </label>
      </div>
      <div class="col-6">
        <label for="NewSupplier" class="d-block">
          New Supplier
          <b-form-input v-model="GainingSupplierId" type="text" disabled/>
        </label>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <label for="ReasonForReturn" class="d-block">
          Reason For Return
          <b-form-input v-model="ReturnReason" type="text" disabled/>
        </label>
      </div>
      <div class="col-6">
        <label for="CustomerName" class="d-block">
          Customer Name
          <b-form-input v-model="CustomerName" type="text" disabled/>
        </label>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <label for="Telephone" class="d-block">
          Telephone
          <b-form-input v-model="CustomerTelephone" type="text" disabled/>
        </label>
      </div>
      <div class="col-6">
        <label for="ContactName" class="d-block">
          Contact Name
          <b-form-input type="text" v-model="InitiatingOfficerContactName" disabled/>
        </label>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <label for="SSD" class="d-block">
          SSD
          <b-form-input v-model="supplyStartDate" type="text" disabled/>
        </label>
      </div>
      <div class="col-6">
        <label for="SED" class="d-block">
          SED
          <b-form-input v-model="supplyEndDate" type="text" disabled/>
        </label>
      </div>
    </div>
    
    <div class="row my-3">
      <div class="col">
        <label for="AdditionalInformation" class="d-block">
          Additional Information
          <textarea v-model="InitiationAdditionalInformation" name="" id="" style="width: 100%;" rows="6" class="d-block" disabled></textarea>
        </label>
      </div>
    </div>

    <div>
      <input v-model="NoContact" type="checkbox" name="NoContact" id="" class="mr-3" disabled>
      No Contact
    </div>
    <div>
      <input v-model="accepted" type="checkbox" name="Accept" id="" class="mr-3" :disabled="viewOnly">
      Accept
    </div>
    <div>
      <input v-model="rejected" type="checkbox" name="Reject" id="" class="mr-3" :disabled="viewOnly">
      Reject
    </div>

    <div v-if="rejected && !viewOnly" class="mt-2">
      <label for="">
        <div>
          Rejection Reason 
        </div>
        <b-form-select v-model="rejectionOrAcceptanceCode" type="text">
          <option v-for="opt of rejectionReasonOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
        </b-form-select>
      </label>
    </div>
    
    <div v-if="!viewOnly" class="mt-3">
      <button class="btn btn-hc mr-3" :disabled="accepted === rejected || rejected && rejectionOrAcceptanceCode == 'FileReceivedAndPassedForProcessing'" 
      data-dismiss="modal"
      data-target="#ViewET"
      @click="respond">Submit</button>
      <button class="btn" 
      data-toggle="modal"
      data-target="#ViewET"
      @click="p_status = null; p_rejectionOrAcceptanceCode = null">Cancel</button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Vue from 'vue';

export default {
  name: 'EtViewGas',

  props: {
    viewOnly: { type: Boolean },

    Id: { type: String },
    SharedId: { type: String },

    Status: { type: String },
    RejectionOrAcceptanceCode: { type: String },

    Received: { type: String },
    CustomerContactDate: { type: String },

    ReturnReason: { type: String },

    CustomerName: { type: String },
    CustomerTelephone: { type: String },

    InitiatingOfficerContactName: { type: String },

    InitiatingSupplierId: { type: String },
    AssociatedSupplierId: { type: String },
    LosingSupplierId: { type: String },
    GainingSupplierId: { type: String },

    InitiationAdditionalInformation: { type: String },
    ReplyAdditionalInformation: { type: String },

    NoContact: { type: Boolean },

    Registration: { type: Object },
  },

  data() {
    return {
      p_status: undefined,
      p_rejectionOrAcceptanceCode: undefined,
    };
  },

  computed: {
    form: {
      get() {
        return {
          SharedId: this.SharedId,
          Status: this.p_status,
          AdditionalInformation: undefined,
          RejectionOrAcceptanceCode: this.rejectionOrAcceptanceCode,
        };
      },
    },

    accepted: {
      get() {
        return /Accepted/.test(this.p_status || this.Status);
      },
      set(val) {
        if (val) {
          this.p_rejectionOrAcceptanceCode = undefined;

          if (this.AssociatedSupplierId === this.GainingSupplierId)
            this.p_status = 'AcceptedByNew';
          else this.p_status = 'AcceptedByOld';
        } else {
          this.p_status = undefined;
        }
      },
    },

    rejected: {
      get() {
        return /Rejected/.test(this.p_status || this.Status);
      },
      set(val) {
        if (val) {
          if (this.AssociatedSupplierId === this.GainingSupplierId)
            this.p_status = 'RejectedByNew';
          else this.p_status = 'RejectedByOld';
        } else {
          this.p_status = undefined;
          this.rejectionOrAcceptanceCode = undefined;
        }
      },
    },

    rejectionOrAcceptanceCode: {
      get() {
        return (
          this.p_rejectionOrAcceptanceCode || this.RejectionOrAcceptanceCode
        );
      },
      set(val) {
        this.p_rejectionOrAcceptanceCode = val;
      },
    },

    statusMapped() {
      return {
        ProposedByNew: 'P',
        AcceptedByNew: 'A',
        RejectedByNew: 'R',
        ProposedByOld: 'Q',
        AcceptedByOld: 'A',
        RejectedByOld: 'N',
        RejectedInitiationWindowExpired: 'T',
      }[this.Status];
    },

    rejectionReasonOptions() {
      return [
        { value: 'UnspecifiedError', label: '01 - Unspecified Error' },
        {
          value: 'IncorrectInitiatingSupplierId',
          label: '10 - Incorrect Initiating Supplier Id',
        },
        {
          value: 'IncorrectRespondingAssociatedSupplierId',
          label: '11 - Incorrect Responding Supplier Id',
        },
        {
          value: 'RequiredAuthorisationNameMissing',
          label: '12 - Required Authorisation Name Missing',
        },
        {
          value: 'ResponseCodeInvalid',
          label: '13 - Status / Response Code Invalid',
        },
        {
          value: 'RecordTypeIdentifierInvalid',
          label: '14 - Record Type Identifier Missing',
        },
        {
          value: 'MprnNotKnownOrInvalid',
          label: '53 - MPRN not known / invalid',
        },
        { value: 'PostcodeMprnMismatch', label: '54 - Postcode/MPRN mismatch' },
        {
          value: 'IncorrectTransferDate',
          label: '55 - Incorrect Transfer Date',
        },
        { value: 'DuplicateRecord', label: '56 - Duplicate record' },
        {
          value: 'MandatoryDataNotPresent',
          label: '57 - Mandatory Data Missing',
        },
      ];
    },

    supplyStartDate: {
      get() {
        return (
          this.Registration &&
          this.Registration.EffectiveFrom &&
          moment(this.Registration.EffectiveFrom).format('ll')
        );
      },
      set() {},
    },

    supplyEndDate: {
      get() {
        return (
          (this.Registration &&
            this.Registration.EffectiveTo &&
            moment(this.Registration.EffectiveTo).format('ll')) ||
          'Ongoing'
        );
      },
      set() {},
    },

    flowbot() {
      return Vue.config.honeycomb.flowbot.gas.domain;
    },
  },

  methods: {
    async respond() {
      try {
        await this.$http.put(
          `https://${this.flowbot}/api/v1/erroneoustransfers/${this.SharedId}`,
          this.form,
          { withCredentials: true }
        );

        this.p_status = undefined;
        this.p_rejectionOrAcceptanceCode = undefined;

        this.$snotify.success('ET Updated', {
          timeout: 20000,
          closeOnClick: true,
        });
      } catch (err) {
        this.$snotify.error(`${err.response.data.UserDescription}`, {
          timeout: 0,
          closeOnClick: true,
        });
      } finally {
        this.$emit('refresh');
      }
    },
  },
};
</script>
